import { CollaboratorSettingsDisabilitiesModel, CollaboratorSettingsFaultsModel } from "app/pages/collaborators/models/CollaboratorSettingsModel";
import { CollaboratorSettingsAllResponse } from "app/types/Ajustes";
import axios from "axios";
const API_URL = process.env.REACT_APP_API_NET;

export const getAllCollaboratorSettings = async (page: number, pageSize: number, numberEmployee?: string | null | undefined, nameEmployee?: string | null | undefined) => {
  try {
    const response = await axios.get<CollaboratorSettingsAllResponse>(`${API_URL}Settings?Page=${page}&PageSize=${pageSize}`);
    return response.data.data;
  } catch (err) {
    console.error("Error fetching CollaboratorSettings", err);
    throw err;
  }
}

export async function createAndUpdateFault(body: CollaboratorSettingsFaultsModel) {
  let response;
  const { periodId, collaboratorId, days, comments, id } = body;
  try {
    response = await axios.post(`${API_URL}CollaboratorFaults`, {
      periodId,
      collaboratorId,
      days,
      comments
    });
    return response.data;
  } catch (error) {
    console.error("Error en editar/crear la falta:", error);
    throw error;
  }
}

export async function createAndUpdateDisabilities(body: CollaboratorSettingsDisabilitiesModel) {
  let response;
  const { periodId, collaboratorId, days, comments, id } = body;
  try {
    response = await axios.post(`${API_URL}CollaboratorDisabilities`, {
      periodId,
      collaboratorId,
      days,
      comments
    });
    return response.data;
  } catch (error) {
    console.error("Error en editar/crear la incapacidad:", error);
    throw error;
  }
}


export async function getAllCollaboratorSettingsName(page: number | string, pageSize: number | string, employeeName?: string) {
  try {
    const response = await axios.get<CollaboratorSettingsAllResponse>(`${API_URL}Settings/GetByEmployeeName?EmployeeName=${employeeName}&Page=${page}&PageSize=${pageSize}`);

    return response.data.data;
  } catch (err) {
    console.error("Error fetching filter Name");
    throw err;
  }
}

export async function getAllCollaboratorSettingsNumber(page: number | string, pageSize: number | string, employeeNumber?: string) {
  try {
    const response = await axios.get<CollaboratorSettingsAllResponse>(`${API_URL}Settings/GetByEmployeeNumber?EmployeeNumber=${employeeNumber}&page=${page}&pageSize=${pageSize}`);

    return response.data.data;
  } catch (err) {
    console.error("Error fetching filter Number");
    throw err;
  }
}

export async function putRequestOpeningSettings(idUser: number | string, idPeriod: number | string) {
  try {
    const response = await axios.put(`${API_URL}Settings/PutRequestOpening?Id_user=${idUser}&Id_period=${idPeriod}`);
    return response.data;
  } catch (err) {
    console.error("Error en putRequestOpeningSettings:", err);
    throw err;
  }
}